import { render, staticRenderFns } from "./zhuhaiInventoryRecordDetail.vue?vue&type=template&id=69fc3363&scoped=true"
import script from "./zhuhaiInventoryRecordDetail.vue?vue&type=script&lang=js"
export * from "./zhuhaiInventoryRecordDetail.vue?vue&type=script&lang=js"
import style0 from "./zhuhaiInventoryRecordDetail.vue?vue&type=style&index=0&id=69fc3363&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69fc3363",
  null
  
)

export default component.exports